export const FETCH_THERAPIST = 'FETCH_THERAPIST';
export const FETCH_THERAPIST_SUCCESS = 'FETCH_THERAPIST_SUCCESS';
export const FETCH_THERAPIST_FAIL = 'FETCH_THERAPIST_FAIL';

export const UPDATE_THERAPIST = 'UPDATE_THERAPIST';
export const UPDATE_THERAPIST_SUCCESS = 'UPDATE_THERAPIST_SUCCESS';
export const UPDATE_THERAPIST_FAIL = 'UPDATE_THERAPIST_FAIL';
